import React, { useState } from 'react';
import classNames from 'classnames';
import { Configure, Index } from 'react-instantsearch';

import { ALGOLIA_INDEX_NAME } from 'commons/constants';
import useAdvancedSearchContext from '../../hooks/useAdvancedSearchContext';
import MenuButtonLabel from './components/MenuButtonLabel';
import SearchCount from './components/SearchCount';
import ProductSearchCount from './components/ProductSearchCount';

const MobileSearchIndexSelector = () => {
  const [expandableOpen, setExpandableOpen] = useState(false);
  const {
    currentSearchSection,
    updateSearchSection,
    isReadyToShipActive,
  } = useAdvancedSearchContext();

  const getSectionTitle = section => {
    switch (section) {
      case ALGOLIA_INDEX_NAME.PRODUCTS:
        return 'Products';
      case ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS:
        return 'Customer Photos';
      case ALGOLIA_INDEX_NAME.REVIEWS:
        return 'Reviews';
      case ALGOLIA_INDEX_NAME.STATIC_PAGES:
        return 'Pages';
      default:
        return 'Products';
    }
  };

  const searchTitle = getSectionTitle(currentSearchSection);

  const handleIndexClick = indexName => {
    updateSearchSection(indexName);
    setExpandableOpen(false);
  };

  return (
    <div
      className={classNames('md:hidden mobile-filters', {
        'mobile-filters--showTopBorder': true,
      })}
    >
      <div className="flex items-center divide-x divide-gray-light7">
        <button
          type="button"
          onClick={() => {
            setExpandableOpen(!expandableOpen);
          }}
          className={classNames(
            'flex-1 min-h-[3rem] space-x-1 flex items-center justify-center text-sm font-bold',
            {
              'mobile-filters__menu-expandable-button--open': expandableOpen,
            }
          )}
          aria-label="Toggle filters"
        >
          <MenuButtonLabel title={searchTitle} />
        </button>
      </div>

      <div
        className={classNames('mobile-filters__expandable relative -top-px', {
          'mobile-filters__expandable--open border-b border-gray-light6': expandableOpen,
          hidden: !expandableOpen,
        })}
      >
        <div className="text-base text-gray font-normal">
          <Index indexName={ALGOLIA_INDEX_NAME.PRODUCTS}>
            <Configure
              facets={['*']}
              facetFilters={isReadyToShipActive ? ['is_in_stock:true'] : []}
              numericFilters={[
                'item_availability=0',
                'visibility>1',
                'visibility<4',
              ]}
              getRankingInfo
            />
            <ProductSearchCount
              title="Products"
              id={ALGOLIA_INDEX_NAME.PRODUCTS}
              selectedOption={currentSearchSection}
              indexClick={handleIndexClick}
            />
          </Index>
          <Index indexName={ALGOLIA_INDEX_NAME.CATEGORIES}>
            <Configure
              numericFilters={['fk_store_id=1']}
              facetFilters={['is_searchable:1']}
              getRankingInfo
            />
          </Index>
          <Index indexName="customer_photos">
            <Configure
              facets={['*']}
              numericFilters=""
              facetFilters={isReadyToShipActive ? ['is_in_stock:true'] : []}
            />
            <SearchCount
              title="Customer Photos"
              id={ALGOLIA_INDEX_NAME.CUSTOMER_PHOTOS}
              selectedOption={currentSearchSection}
              indexClick={handleIndexClick}
            />
          </Index>
          <Index indexName="reviews">
            <Configure facets={['*']} numericFilters="" facetFilters="" />
            <SearchCount
              title="Reviews"
              id={ALGOLIA_INDEX_NAME.REVIEWS}
              selectedOption={currentSearchSection}
              indexClick={handleIndexClick}
            />
          </Index>
          <Index indexName={ALGOLIA_INDEX_NAME.STATIC_PAGES}>
            <Configure
              numericFilters={[
                'is_active=1',
                'show_in_search=1',
                'fk_store_id=1',
              ]}
            />
            <SearchCount
              title="Pages"
              id={ALGOLIA_INDEX_NAME.STATIC_PAGES}
              selectedOption={currentSearchSection}
              indexClick={handleIndexClick}
            />
          </Index>
        </div>
      </div>
    </div>
  );
};

export default MobileSearchIndexSelector;
